/// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from '../../utils/dynamicClassName';

type Props = {
  message: string
};

class ErrorMessage extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    message: 'Adresse email invalide'
  };

  render() {
    const classNames = dynamicClassName('input__error');
    return <span className={classNames.build()}>{this.props.message}</span>;
  }
}

export default ErrorMessage;
